import { Outlet } from 'react-router-dom';
import { ApiCacheProvider } from '@/pages/ApiCache.context';
import { SignHeader } from '@/components/Header';
import { AppProvider } from './App.context';
import { SignProvider } from './SignLayout.context';
import styles from './SignLayout.module.scss';

const SignLayout = () => {
  /*
   * Please do not add any Suspense here as this feels somehow broken!
   * */
  return (
    <ApiCacheProvider token={sessionStorage.getItem('token')}>
      <AppProvider>
        <SignHeader />
        <SignProvider>
          <main className={styles.main}>
            <Outlet />
          </main>
        </SignProvider>
      </AppProvider>
    </ApiCacheProvider>
  );
};

export default SignLayout;
